import { InnerHtml } from '@/components/generic/InnerHtml';
import { useStakeOverviewDetailQuery } from '@/graphql/generated';
import { LoaderFullscreen } from '@/components/layout/Loader';
import { MessageBox, MessageBoxType } from '@/components/layout/MessageBox';
import { useTranslation } from '@/hooks/useTranslation';

export function StakeOverviewDetail({ stakeId }: { stakeId: string }) {
  const { t, translateProperty } = useTranslation();
  const query = useStakeOverviewDetailQuery({
    variables: {
      id: stakeId,
    },
    fetchPolicy: 'cache-and-network',
  });

  if (query.loading) {
    return <LoaderFullscreen />;
  }

  if (query.error) {
    return (
      <MessageBox type={MessageBoxType.Error}>{query.error.message}</MessageBox>
    );
  }

  if (!query.data?.diagnosticStake) {
    return null;
  }

  const stake = query.data?.diagnosticStake;
  const description = translateProperty(stake, 'description');
  const financialMaterialityDescription = translateProperty(
    stake,
    'financialMaterialityDescription',
  );
  const impactMaterialityDescription = translateProperty(
    stake,
    'impactMaterialityDescription',
  );

  // No data, empty placeholder
  if (
    !description &&
    !financialMaterialityDescription &&
    !impactMaterialityDescription
  ) {
    return (
      <div className="italic text-gray-500 text-center py-4 sami-body-small">
        {t('stake.detailModal.overview.placeholder')}
      </div>
    );
  }

  return (
    <div className="p-4 divide-y divide-gray-100 space-y-8">
      {description && (
        <div className="pt-8">
          <h6>{t('stake.detailModal.overview.description')}</h6>
          <InnerHtml
            html={description}
            className="sami-heading-small"
          />
        </div>
      )}
      {financialMaterialityDescription && (
        <div className="pt-8">
          <h6>{t('stake.detailModal.overview.financial_materiality')}</h6>
          <InnerHtml
            html={financialMaterialityDescription}
            className="sami-heading-small"
          />
        </div>
      )}
      {impactMaterialityDescription && (
        <div className="pt-8">
          <h6>{t('stake.detailModal.overview.impact_materiality')}</h6>
          <InnerHtml
            html={impactMaterialityDescription}
            className="sami-heading-small"
          />
        </div>
      )}
    </div>
  );
}
